// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dpvc","textarea":"styles_textarea__1ZKEo"};